import { cn } from "@/lib/utils";

import React from "react";

export default function EstateDetails({ estate, className }) {
  // Helper function to display information if it exists

  const renderDetail = (label, value) => {
    if (value) {
      return (
        <div className="grid grid-cols-2 py-2 border-b border-gray-200">
          <span className="text-gray-500 font-medium">{label}:</span>

          <span className="text-gray-800 font-semibold">{value}</span>
        </div>
      );
    }

    return null;
  };

  // --- Special Handlers (updated for {value: ...} and specific list) ---
  const renderPrice = () => {
    if (estate.price?.value) {
      return renderDetail("Preis", `${estate.price.value} €`);
    }
    return null;
  };

  const renderCommission = () => {
    if (estate.courtage?.value) {
      return renderDetail("Käuferprovision", `${estate.courtage.value}%`);
    }
    return null;
  };

  const formatCurrency = (value) => {
    if (value) {
      return `${value} €`;
    }
    return null;
  };

  return (
    <div className={cn("p-4 rounded-lg py-7 bg-prime-50", className)}>
      <h2 className="text-2xl font-medium text-prime-950 font-serif mb-5">
        Details zur Immobillie
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {/* {renderDetail('Adresse', estate.address)}

   {renderDetail('PLZ', estate.zip_code)}

   {renderDetail('Stadt', estate.city)}

   {renderDetail('Region', estate.region)} */}

        {renderPrice()}

        {renderDetail(
          "Wohnfläche ca.",
          estate.living_space?.value ? `${estate.living_space.value} m²` : null
        )}

        {renderDetail(
          "Grundstücksfläche ca.",
          estate.plot_area?.value ? `${estate.plot_area.value} m²` : null
        )}

        {renderDetail(
          "Gewerbefläche ca.",
          estate.industrial_area?.value
            ? `${estate.industrial_area.value} m²`
            : null
        )}

        {renderDetail("Zimmer", estate.number_of_rooms?.value)}

        {renderDetail("Baujahr ca.", estate.construction_year?.value)}

        {renderDetail(
          "Letzte Modernisierung",
          estate.last_refurbishment?.value
        )}

        {renderDetail("Objektzustand", estate.condition?.value)}

        {renderDetail(
          "Qualität der Ausstattung",
          estate.interior_quality?.value
        )}

        {/* {renderDetail('Energieausweistyp', estate.building_energy_rating_type?.value)}

   {renderDetail('Energieeffizienzklasse', estate.energy_efficiency_class?.value)}

   {renderDetail('Endenergiebedarf', estate.thermal_characteristic?.value ? `${estate.thermal_characteristic.value} kWh/(m²·a)` : null)}

   {renderDetail('Wesentlicher Energieträger', estate.firing_types?.value)}

   {renderDetail('Heizungsart', estate.heating_type?.value)}

   {renderCommission()}

   {renderDetail('Ausstattung', estate.furnishing_note?.value)}

   {renderDetail('Lagebeschreibung', estate.location_note?.value)}

   {renderDetail('Beschreibung', estate.description_note?.value)} */}

        {renderDetail(
          "Vermietbare Fläche ca.",
          estate.net_floor_space?.value
            ? `${estate.net_floor_space.value} m²`
            : null
        )}

        {renderDetail("Objektart", estate.investment_type?.value)}

        {renderDetail(
          "Monatliche Nettomiete Soll",
          estate.rental_income_target?.value
            ? `${estate.rental_income_target.value} €`
            : null
        )}

        {renderDetail(
          "Rendite Soll",
          estate.yield_target?.value ? `${estate.yield_target.value}%` : null
        )}

        {renderDetail("Personenaufzug", estate.lift?.value ? "Ja" : null)}

        {renderDetail("Keller", estate.cellar?.value ? "Ja" : null)}

        {renderDetail("Balkon / Terrasse", estate.balcony?.value ? "Ja" : null)}

        {renderDetail(
          "Garten / -mitbenutzung",
          estate.garden?.value ? "Ja" : null
        )}

        {renderDetail(
          "Einliegerwohnung vorhanden",
          estate.lodger_flat?.value ? "Ja" : null
        )}

        {renderDetail(
          "Denkmalschutzobjekt",
          estate.monument?.value ? "Ja" : null
        )}

        {/* Display images if they exist */}

        {/* {estate.images && estate.images.length > 0 && (

     <div className="mt-4">

    <h3 className="text-xl font-semibold mb-2">Bilder:</h3>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

      {estate.images.map((image, index) => (

     <img

       key={index}

       src={image.url}

       alt={image.title || `Bild ${index + 1}`}

       className="w-full h-auto rounded-md shadow-sm"

     />

      ))}

    </div>

     </div>

   )} */}
      </div>
       {" "}
    </div>
  );
}
